// import css from "./product.module.css";
// import hero from "../../img/hero.png";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import { auth, db } from "../../firebase";
// export default function Hero({ oneProd }) {
//   const navigate = useNavigate();
//   const [heroData, setHeroData] = useState(null);

//   useEffect(() => {
//     const fetchHeroData = async () => {
//       try {
//         const heroQuery = query(
//           collection(db, "hero"),
//           where("name", "==", oneProd.bookHero),
//         );
//         const querySnapshot = await getDocs(heroQuery);

//         querySnapshot.forEach((doc) => {
//           const heroData = doc.data();

//           setHeroData(heroData);
//         });
//       } catch (error) {
//         console.error("Помилка при отриманні документів:", error);
//       }
//     };

//     fetchHeroData();
//   }, [oneProd.bookHero]);
//   return (
//     <div className={css.heroWrapp}>
//       {oneProd && oneProd.heroFoto && (
//         <div className={css.heroPicRo}>
//           <div className={css.heroPicRoteta}>
//             <img src={oneProd.heroFoto} className={css.theSameHeroPic} />
//           </div>
//         </div>
//       )}
//       {oneProd && !oneProd.heroFoto && (
//         <div className={css.heroPicRo}>
//           <div className={css.heroPicRoteta}>
//             <img src={hero} className={css.theSameHeroPic} />
//           </div>
//         </div>
//       )}
//       {/* <div className={css.heroPicRo}>
//         <div className={css.heroPicRoteta}>
//           <img src={hero} />
//         </div>
//       </div> */}

//       <div className={css.wrapHeroText}>
//         <h1 className={css.wrapHeroTextH1}>{oneProd.heroLabelText}</h1>
//         <p className={css.wrapHeroTextP}>{oneProd.heroParagrafText}</p>
//         <button
//           onClick={() => navigate(`/hero/${heroData.uid}`)}
//           className={css.heroButton}
//         >
//           Сторінка героя
//         </button>
//       </div>
//     </div>
//   );
// }
import css from "./product.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export default function Hero({ oneProd }) {
  const navigate = useNavigate();
  const [heroData, setHeroData] = useState(null);

  const hasRealText = (value) => {
    if (value === null || value === undefined) return false;

    return (
      String(value)
        .replace(/\u00A0/g, " ")
        .trim().length > 0
    );
  };

  const heroPhoto = oneProd?.heroFoto;
  const heroTitle = oneProd?.heroLabelText;
  const heroDescription = oneProd?.heroParagrafText;
  const heroName = oneProd?.bookHero;

  const shouldShowHeroBlock =
    hasRealText(heroPhoto) &&
    hasRealText(heroTitle) &&
    hasRealText(heroDescription);

  useEffect(() => {
    const fetchHeroData = async () => {
      if (!shouldShowHeroBlock || !hasRealText(heroName)) {
        setHeroData(null);
        return;
      }

      try {
        const heroQuery = query(
          collection(db, "hero"),
          where("name", "==", String(heroName).trim()),
        );

        const querySnapshot = await getDocs(heroQuery);

        if (querySnapshot.empty) {
          setHeroData(null);
          return;
        }

        const firstHeroDoc = querySnapshot.docs[0];
        setHeroData({
          id: firstHeroDoc.id,
          ...firstHeroDoc.data(),
        });
      } catch (error) {
        console.error("Помилка при отриманні героя:", error);
        setHeroData(null);
      }
    };

    fetchHeroData();
  }, [heroName, shouldShowHeroBlock]);

  const goToHeroPage = () => {
    if (!heroData?.uid) return;

    navigate(`/hero/${heroData.uid}`);
  };

  if (!oneProd || !shouldShowHeroBlock) {
    return null;
  }

  return (
    <div className={css.heroWrapp}>
      <div className={css.heroPicRo}>
        <div className={css.heroPicRoteta}>
          <img
            src={String(heroPhoto).trim()}
            className={css.theSameHeroPic}
            alt={String(heroTitle).trim()}
          />
        </div>
      </div>

      <div className={css.wrapHeroText}>
        <h1 className={css.wrapHeroTextH1}>{String(heroTitle).trim()}</h1>

        <p className={css.wrapHeroTextP}>{String(heroDescription).trim()}</p>

        {heroData?.uid && (
          <button onClick={goToHeroPage} className={css.heroButton}>
            Сторінка героя
          </button>
        )}
      </div>
    </div>
  );
}
